import { ALERT } from '../constants/alert.constants';

export const alertActions = {
  success,
  error,
  clear,
  warning,
};

function success(message: string) {
  return {type: ALERT.SUCCESS, message};
}

function warning(message: string) {
    return {type: ALERT.WARNING, message};
}

function error(message: any) {
  return {type: ALERT.ERROR, message};
}

function clear() {
  return {type: ALERT.CLEAR};
}
